import { Link } from "react-router-dom";
import styled, { css } from "styled-components/macro";

import icon_close from "../../assets/icons/icon_close.svg"
import { ReactComponent as SearchIcon } from "../../assets/icons/icon_search_mobile.svg";
import { MobileButtonWrapper } from "../../styles/sharedStyles";

export const MenuWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  //height: 100vh;
  height: 100dvh;
  background-color: #55749F;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
`;

export const Search = styled(SearchIcon)`
  width: 18px;
  height: 18px;
  display: block;

    path {
      stroke: white !important;
    }
`;

export const Logo = styled.img`
  width: 147px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CustomMButtonWrapper = styled(MobileButtonWrapper)`
  padding-right: 17px;
`

export const Close = styled.button`
  display: block;
  width: 18px;
  height: 18px;
  background-image: url(${icon_close});
  background-size: contain;
  background-repeat: no-repeat;
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  margin: 0 43px;
`;

export const Title = styled.h2`
  font-size: 22px;
  line-height: 31px;
  font-weight: 400;
  padding: 6px 0;
  display: block;
  margin-bottom: 14px;
`

export const MenuSection = styled.section`
  margin-bottom: 36px;
`;

export const MenuList = styled.ul``

export const MenuItem = styled.li``

export const MenuLink = styled(Link)`
  display: block;
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  padding: 6px 0;
  line-height: 22px;
  font-size: 16px;
  margin-bottom: 6px;
    
    &:last-child {
      margin-bottom: 0;
    }
`;

export const MenuLinkCustom = styled(MenuLink)`
  font-size: 22px;
  line-height: 31px;
  margin: 0;
  font-weight: 400;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 36px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

type TMenuButtonProps = {
  $isCLevelPage?: boolean;
}

export const MenuButton = styled.a<TMenuButtonProps>`
  text-align: center;
  width: 100%;
  font-size: 18px;
  border-radius: 30px;
  background-color: #fff;
  font-weight: 500;
  color: #55749F;
  height: 50px;
  text-decoration: none;
  line-height: 50px;
  transition: 0.2s;

  ${({ $isCLevelPage }) => $isCLevelPage
    ? css`
      &:hover {
        background-color: #BFDCF5;
        color: #141414;
      }
    `
    : ""};
`;

export const SecondButton = styled(MenuButton)`
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
`

export const SocialLinks = styled.div`
  font-size: 16px;
  text-align: center;
  display: flex;
  justify-content: space-between;
`;

export const SocialLink = styled.a`
  width: 25%;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
`

export const Separator = styled.div`
  color: #fff;
`

export const BottomBar = styled.div`
  margin: 0 43px 24px;
`
